import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAlumniByYear } from "../components/apifa";
import axios from "axios"; // Assuming you're using axios for API calls

const startYear = 1990;
const currentYear = 2025;
const yearsRange = Array.from(
  { length: currentYear - startYear + 1 },
  (_, i) => startYear + i
);

const DashboardAlumni = () => {
  const navigate = useNavigate(); // Initialize the navigate function
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAlum, setSelectedAlum] = useState(null);

  // Function to handle opening the modal and setting the selected alum
  const handleOpenModal = (alumnus) => {
    setSelectedAlum(alumnus);
    setIsModalOpen(true);
  };

  // Function to handle closing the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedAlum(null); // Clear selectedAlum when closing modal
  };
  const [selectedYear, setSelectedYear] = useState(2025); // Default to the current year (2025)
  const [alumniData, setAlumniData] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Fetch alumni data when a year is selected
  useEffect(() => {
    // Fetch alumni data when the selected year changes
    const fetchAlumniData = async () => {
      try {
        const data = await getAlumniByYear(selectedYear);
        setAlumniData(data);
      } catch (error) {
        setAlumniData([]); // Handle error by clearing data
      }
    };

    fetchAlumniData();
  }, [selectedYear]); 

 

  const handleYearClick = (year) => {
    setSelectedYear(year);
    if (window.innerWidth < 768) setIsSidebarOpen(false); // Close sidebar on mobile
  };


  const handleLogout = () => {
    // Clear user data from localStorage
    localStorage.removeItem("userToken");
    localStorage.removeItem("userID");

    // Redirect to the alumni page (you can change the route to wherever you want to redirect)
    navigate("/alumni"); // Adjust the path as necessary
  };


  return (
    <div className="flex flex-col md:flex-row max-h-[90vh] min-h-[90vh] overflow-hidden px-4 pt-8 mx-auto">
  {/* Sidebar */}
      <nav
        className={`${
          isSidebarOpen ? "block" : "hidden"
        } md:block md:w-64 w-full bg-gray-800 text-white p-4 overflow-y-auto`}
      >
        <div className="flex justify-between items-center mb-4">
          <span className="text-lg font-bold">Alumni Directory</span>
          {/* Close button for mobile */}
          <button
            onClick={() => setIsSidebarOpen(false)}
            className="text-white md:hidden"
          >
            ✕
          </button>
        </div>
        <ul className="space-y-2">
          {yearsRange.map((year) => (
            <li key={year}>
              <button
                onClick={() => handleYearClick(year)}
                className={`block p-2 w-full text-left hover:bg-gray-700 rounded transition ${
                  selectedYear === year ? "bg-gray-700" : ""
                }`}
              >
                {year}
              </button>
            </li>
          ))}
        </ul>
        <hr className="my-4 border-gray-600" />
        <button
          onClick={handleLogout}
          className="w-full bg-red-600 text-white p-2 rounded mt-4 hover:bg-red-700"
        >
          Logout
        </button>
      </nav>

      {/* Mobile sidebar toggle */}
      <button
        className="md:hidden bg-gray-800 text-white p-2"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        {isSidebarOpen ? "Close Sidebar" : "Open Sidebar"}
      </button>

      {/* Main Content */}
      
      <main className="flex-1 p-6 bg-gray-100 overflow-y-auto">
  <h1 className="text-2xl font-bold mb-4 text-black">Welcome to the Alumni Dashboard</h1>
  {selectedYear ? (
    <div>
      <h2 className="text-xl font-semibold mb-4 text-black">
        Alumni from the year {selectedYear}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {alumniData.length > 0 ? (
          alumniData.map((alumnus) => (
            <div
              key={alumnus.email}
              className="bg-gray-800 text-white rounded-lg shadow-md p-4 flex flex-col items-center"
            >
              <img
                src={`${process.env.REACT_APP_API_ENDPOINT}${alumnus.image}`}
                alt={alumnus.name}
                className="w-24 h-24 object-cover rounded-full mb-4 border-4 border-lime-300"
              />
              <h3 className="text-lg font-semibold mb-2 text-lime-300">{alumnus.name}</h3>
              <p className="text-sm mb-1">Program: {alumnus.program}</p>
              <p className="text-sm mb-1">Grade: {alumnus.grade}</p>
              <p className="text-sm mb-1">Email: {alumnus.email}</p>

              {/* Tags display */}
              <div className="flex flex-wrap space-x-2 mt-4">
                {alumnus.tags.split(",").map((tag, tagIndex) => (
                  <span
                    key={tagIndex}
                    className="bg-blue-200 text-blue-800 text-xs font-semibold px-2 py-1 rounded mb-2"
                  >
                    {tag.trim()} {/* Trim spaces if any */}
                  </span>
                ))}
              </div>
            </div>
          ))
        ) : (
          <p>No alumni data available for this year.</p>
        )}
      </div>
    </div>
  ) : (
    <p>Select a year from the sidebar to view alumni details.</p>
  )}
</main>

{/* Modal for detailed alumni info */}
{isModalOpen && selectedAlum && (
  <div className="fixed inset-0 flex justify-center items-center bg-gray-700 bg-opacity-75 z-50">
    <div className="bg-gray-800 p-6 rounded-lg w-11/12 max-w-4xl relative mt-20">
      {/* Close Button */}
      <button
        onClick={handleCloseModal}
        className="absolute top-2 right-2 text-2xl font-bold text-gray-600"
      >
        &times;
      </button>

      {/* Modal Content */}
      <div className="flex flex-col lg:flex-row items-center lg:items-start">
        {/* Profile Image */}
        <div className="w-40 h-40 lg:w-48 lg:h-48 mb-4 lg:mb-0">
          <img
            src={selectedAlum.profile_image || "https://via.placeholder.com/150"}
            alt={`Profile picture of ${selectedAlum.name}`}
            className="w-full h-full object-cover rounded-full"
          />
        </div>

        {/* Description and Info */}
        <div className="lg:ml-6">
          <div className="mb-4">
            <p>
              <strong className="text-lime-300">Program:</strong> {selectedAlum.program}
            </p>
            <p>
              <strong className="text-lime-300">Batch:</strong> {selectedAlum.batch}
            </p>
          </div>
          <h3 className="text-2xl font-semibold mb-2 text-lime-300">{selectedAlum.name}</h3>
          <p className="text-lg mb-4">{selectedAlum.description || "No description available"}</p>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default DashboardAlumni;
